import { getStore as folderStore } from './store/store';
export { default as getStore } from './store/store';

// Import mutators
import './mutators/setLoadingStateForFolderTreeMutator';
export { addFoldersToFolderTable } from './mutators/addFoldersToFolderTableMutator';
export { setFolderLoadingStateMutator } from './mutators/setFolderLoadingStateMutator';

// export types
export type { default as FolderTreeData } from './store/schema/FolderTreeData';

export type { default as FolderStore } from './store/schema/FolderStore';
export { default as FolderTreeLoadStateEnum } from './store/schema/FolderTreeLoadStateEnum';
export { default as getFullFolderId } from './util/getFullFolderId';
export {
    getFolderPermissionsSuccess,
    getFolderPermissionsFailed,
    updateFolderPermissionsSuccess,
    updateFolderPermissionsFailed,
    initializeFolderViewStates,
    type INITIALIZE_FOLDER_VIEW_STATESActionMessage,
    type UpdateFolderPermissionsItem,
    type InitializeFolderTreeCompletedActionMessage,
    onInitializeFolderTreeCompleted,
    searchFoldersFetchCompleted,
    type SearchFoldersFetchCompletedActionMessage,
} from './actions/publicActions';
export {
    initializeSharedFolderRoots,
    type INITIALIZE_SHARED_FOLDERSActionMessage,
} from './actions/initializeSharedFolderRoots';
export { setLoadingStateForFolderTree } from './util/setLoadingStateForFolderTree';
export {
    manualSyncFoldersSortChange,
    type MANUAL_SYNC_FOLDERS_SORT_CHANGEActionMessage,
} from './actions/manualSyncFoldersSortChange';

export { default as getArchiveFolderTreeRootFolder } from './selectors/getArchiveFolderTreeRootFolder';
export { default as getPrimaryFolderTreeRootFolder } from './selectors/getPrimaryFolderTreeRootFolder';
export { default as getFolderTable } from './selectors/getFolderTable';
export { default as getFolderTreeLoadingState } from './selectors/getFolderTreeLoadingState';
export { default as getFolderTreeHasMoreData } from './selectors/getFolderTreeHasMoreData';
export { default as getFolderTreeCurrentLoadedIndex } from './selectors/getFolderTreeCurrentLoadedIndex';
export { default as getSharedFolderRoot } from './selectors/getSharedFolderRoot';
export { default as getEffectiveFolderDisplayName } from './selectors/getEffectiveFolderDisplayName';
export { default as isFolderLoaded } from './selectors/isFolderLoaded';
export { default as onFolderHierarchyResponse } from './util/onFolderHierarchyResponse';
export { default as initializeArchiveFolderTree } from './util/initializeArchiveFolderTree';
export { setFolderTreeData } from './mutators/setFolderTreeData';
export { initializeFolderTreeData } from './util/initializeFolderTreeData';
export { getPrimaryMailFolders } from './util/getPrimaryMailFolders';
export { default as onFindFolderSuccess } from './util/onFindFolderSuccess';
export { default as getSharedFolderArchiveMailboxInfo } from './selectors/getSharedFolderArchiveInformation';
export { setSharedFolderArchiveInformationMutator } from './actions/setSharedFolderArchiveInformation';
export { getArchiveDisplayName } from './util/getArchiveDisplayName';
export { default as isFolderUnderMsg, isFolderOrSubFolderOfMsgRoot } from './util/isFolderUnderMsg';
export {
    isUnderDistinguishedFolder,
    isMessageFolderRoot,
    default as isFolderOrSubFolderOfDistinguishedFolder,
} from './util/isFolderOrSubFolderOfDistinguishedFolder';
export type { FolderTableState } from './util/isFolderOrSubFolderOfDistinguishedFolder';
export {
    getFolderByDistinguishedId,
    getRootFolderForMailboxInfo,
    isFolderInMailboxType,
    areFoldersInSameMailbox,
} from './util/folderUtility';
export { getMailboxInfoForFolderId } from './util/getMailboxInfoForFolderId';
export { isPublicFolder } from './util/idConverter';
export { getMailboxFolderTreeData } from './selectors/getMailboxFolderTreeDataTable';
export {
    buildUnreadTotalCountTooltip,
    buildUnreadTotalCountContextMenuLabel,
    getDefaultFolderCountDisplayMode,
} from './util/folderCountUtility';
export { getCustomFolderCount } from './util/getCustomFolderCount';
export {
    getExpiredSearchFolderStore,
    isSearchFolderExpired,
    getExpiredSearchFolderDefinition,
} from './store/expiredSearchFolderStore';
export type { ExpiredSearchFolderStore } from './store/expiredSearchFolderStore';

export default folderStore;

export {
    lazyGetArchiveFolders,
    lazyGetFolderPermissions,
    lazyUpdateFolderPermissions,
    lazyUpdateFolderPermissionsInFolderStore,
    lazyFetchArchiveDumpsterFolder,
    lazyArePermissionArraysEqual,
    lazyGetSharedFoldersForSpecificRoot,
    lazyUpdateFolder,
    lazyFetchFavoriteFolders,
    lazyFetchMoreFolders,
    lazyCreateNewFolderInStore,
    lazyDeleteFoldersFromFolderTable,
    lazyRemoveFolderFromParentFolder,
    lazyMoveFolderToParentFolder,
    lazyFetchFavoriteFoldersResponse,
    lazyOutlookFavoritePersonaSearchFoldersLoadedMutator,
    lazyGetChildFolderIds,
    lazyGetChildFolderNames,
    lazyToggleIsAlphabetizeFoldersEnabled,
    lazyUpdateFoldersParentFolder,
    lazyUpdateFolderId,
    lazyRemoveExpiredSearchFolderMutator,
    lazyDetectExpiredSearchFoldersFromDefinitions,
} from './lazyFunctions';

// Required for actions that depend on them
